import type { ChannelMessage } from './queries';
import { translate } from '@/lib/i18n/runtime';

/**
 * The team-chat API reserves `parent_message_id` for thread replies and has no
 * separate top-level reply field. Keep a durable, human-readable quote in the
 * sent content instead of inventing an unsupported wire contract.
 */
export function channelReplyExcerpt(message: ChannelMessage): string {
  const raw =
    message.message_type === 'agent_approval'
      ? translate('reply.approval', { tool: message.agent_card?.tool ?? translate('reply.sensitiveTool', {}, 'teamchat') }, 'teamchat')
      : message.content?.trim() ||
        (message.file_name ? translate('reply.file', { name: message.file_name }, 'teamchat') : translate('reply.noText', {}, 'teamchat'));
  const normalized = raw.replace(/\s+/g, ' ').trim();
  return normalized.length > 180 ? `${normalized.slice(0, 177)}…` : normalized;
}

export function channelReplyPrefix(message: ChannelMessage): string {
  return translate('reply.prefix', { name: message.user_name ?? translate('reply.message', {}, 'teamchat'), excerpt: channelReplyExcerpt(message) }, 'teamchat');
}
